const state = {
    data: undefined
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
